import React, {useEffect, useRef, useState} from "react";
import {classNames} from "../../../util/util-helpers";
import {numberWithCommasToBack} from "../../../../util/util-formaters";
import PencilAltOutlineIcon from "@heroicons/react/24/outline/PencilSquareIcon";
import {ExclamationCircleIcon} from "@heroicons/react/20/solid";
import {isNumber} from "chart.js/helpers";
import Tooltip from "../../tooltip";

export default function FieldCellMoneySimple({
                                                 classFocused,
                                                 classNotFocused,
                                                 value = "",
                                                 name,
                                                 onChange,
                                                 disabled,
                                                 errorMessage,
                                                 translate
                                             }) {
    const hasErrors = !!errorMessage?.length;
    const inputRef = useRef();
    const [isFocused, setIsFocused] = useState(false);
    const [innerValue, setInnerValue] = useState(value);        // Initial and useEffect

    const inputClass = classNames(
        isFocused
            ? classFocused ?? "form-control text-xs text-right pl-2 pr-4"
            : classNotFocused ?? "text-right text-tm-gray-700 w-full border border-transparent focus:border-primary placeholder:text-tm-gray-500 bg-transparent focus:shadow-xs py-1 px-1.5 focus:outline-hidden focus:bg-field focus:ring-0 focus:border-primary sm:text-sm disabled:bg-tm-gray-50 disabled:text-tm-gray-700 focus:text-tm-gray-700 rounded-input"
    )

    function handleFocus() {
        if (!disabled) {
            setIsFocused(true);
            setInnerValue(value);
            setTimeout(function () {
                if (inputRef?.current?.setSelectionRange) {
                    inputRef.current.setSelectionRange(0, inputRef.current?.value?.length)
                }
            }, 0);
        }
    }

    function handleInputChange(value) {
        setInnerValue(value);
    }

    function handleBlur() {
        setIsFocused(false);
        onChange(name, innerValue);
        if (isNumber(value)) {
            setInnerValue(() => numberWithCommasToBack((value ?? "")).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            }).replace("$", ""));
        }
    }

    function handleKeyDown(e) {
        if (e.key === "Enter") {
            onChange(name, innerValue);
        }
    }

    useEffect(() => {
        if (!isFocused && isNumber(value)) {
            setInnerValue(numberWithCommasToBack((value ?? "")).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            }).replace("$", ""));
        } else {
            setInnerValue(value);
        }
    }, [value]);

    return (
        <label
            className="bg-inherit w-full relative flex h-full items-center" onClick={(e) => {
            e.stopPropagation();
        }}
        >
            <div className="pointer-events-none absolute -left-1 top-0 flex items-center h-9 pl-3"><span
                className="text-gray-500 sm:text-sm">$</span></div>

            <input
                className={inputClass}
                ref={inputRef}
                type="text"
                name={name ?? ""}
                value={innerValue}
                onKeyDown={handleKeyDown}
                onChange={(e) => handleInputChange(e.target.value)}
                onFocus={handleFocus}
                disabled={disabled}
                onBlur={handleBlur}
            />

            {!isFocused && !hasErrors && !disabled && (
                <PencilAltOutlineIcon className="w-5 h-5 text-tm-gray-400 absolute -right-5 top-1/2 -translate-y-1/2"/>
            )}


            {(!isFocused && !!hasErrors) && (
                <>
                    <Tooltip content={translate(errorMessage[0])}>
                        <ExclamationCircleIcon
                            className="w-5 h-5 text-red-600 absolute -right-4 top-1/2 -translate-y-1/2 z-50"/>
                    </Tooltip>
                    <div className="bg-red-600/10 absolute inset-0 -right-5 rounded-btn"/>
                </>
            )}


        </label>
    );
}
